import { widgetApi } from '../../config';

interface AuthCaptchaData {
  link: string;
}

export const getAuthCaptchaLink = async (): Promise<AuthCaptchaData> => {
  try {
    const response = await fetch(`${widgetApi}/auth/captcha/link`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Запрос капчи не прошел');
    }

    const data: AuthCaptchaData = await response.json();

    return data;
  } catch (_) {
    throw new Error('Произошла ошибка при получении ссылки на капчу');
  }
};
